import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DynamicEnrollAnalysisReason = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.DYNAMIC_ENROLL"
  });
};
export default DynamicEnrollAnalysisReason;